import React from 'react';
// import { Order } from '../../types';
import { getDateUrgency, getDateColorClass } from '../../utils/dateUtils';
import { BsCalendar, BsExclamationCircle, BsFileText, BsPerson, BsTruck } from 'react-icons/bs';
import { OutboundOrder } from '../../../../api/warehouse/generated/src';

interface OrderDetailsProps {
  order: OutboundOrder;
}

export const OrderDetails: React.FC<OrderDetailsProps> = ({ order }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4 space-y-3">
      <h2 className="text-lg md:text-xl font-bold text-gray-800 mb-4">Auftragsdetails</h2>
      
      <div className="flex items-start gap-2">
        <BsFileText size={20} className="text-gray-600 mt-1" />
        <div>
          <p className="text-sm text-gray-600">Auftragsnummern</p>
          <p className="font-semibold">{order.orderNumber}</p>
          {order.subOrders && order.subOrders.length > 0 && (
            <div className="mt-1">
              {order.subOrders.map((so, idx) => {
                const urgency = getDateUrgency(so.deliveryDate);
                const colorClass = getDateColorClass(urgency);
                return (
                  <p key={idx} className="text-sm">
                    <span className="text-gray-600">{so.orderNumber} - </span>
                    <span className={colorClass}>
                      Lieferung: {new Date(so.deliveryDate).toLocaleDateString('de-DE')}
                      {urgency === 'overdue' && ' (ÜBERFÄLLIG)'}
                    </span>
                  </p>
                );
              })}
            </div>
          )}
        </div>
      </div>
      
      <div className="flex items-start gap-2">
        <BsPerson size={20} className="text-gray-600 mt-1" />
        <div>
          <p className="text-sm text-gray-600">Kunde</p>
          <p className="font-semibold">{order.customer}</p>
          <p className="text-sm text-gray-500">{order.customerNumber}</p>
        </div>
      </div>
      
      <div className="flex items-start gap-2">
        <BsCalendar size={20} className="text-gray-600 mt-1" />
        <div>
          <p className="text-sm text-gray-600">Termine</p>
          <p className="text-sm">Auftrag: {new Date(order.orderDate).toLocaleDateString('de-DE')}</p>
          <p className={`text-sm ${getDateColorClass(getDateUrgency(order.deliveryDate))}`}>
            Lieferung: {new Date(order.deliveryDate).toLocaleDateString('de-DE')}
            {getDateUrgency(order.deliveryDate) === 'overdue' && ' (ÜBERFÄLLIG)'}
          </p>
        </div>
      </div>
      
      <div className="flex items-start gap-2">
        <BsTruck size={20} className="text-gray-600 mt-1" />
        <div>
          <p className="text-sm text-gray-600">Versandart</p>
          <p className="font-semibold">{order.shippingMethod}</p>
        </div>
      </div>
      
      {order.notes && (
        <div className="flex items-start gap-2">
          <BsExclamationCircle size={20} className="text-orange-600 mt-1" />
          <div>
            <p className="text-sm text-gray-600">Hinweise</p>
            <p className="text-sm font-semibold text-orange-600">{order.notes}</p>
          </div>
        </div>
      )}
    </div>
  );
};